import { atom } from 'jotai';


const templatesAtom = atom([]);

export { templatesAtom };